import { MatDialogRef } from '@angular/material/dialog';
import { UxserviceService } from '../services/uxservice.service';

export abstract class DocumentEditorDialogBaseComponent {
  private baselineSnapshot: any = null;

  constructor(
    protected dialogRef: MatDialogRef<any>,
    protected ux: UxserviceService,
  ) {
    this.dialogRef.disableClose = true;
  }

  protected markBaseline(): void {
    this.baselineSnapshot = this.buildDirtySnapshot();
  }

  protected markClean(): void {
    this.baselineSnapshot = this.buildDirtySnapshot();
  }

  protected get hasUnsavedChanges(): boolean {
    if (!this.baselineSnapshot) {
      return false;
    }

    return JSON.stringify(this.baselineSnapshot) !== JSON.stringify(this.buildDirtySnapshot());
  }

  protected async attemptClose(closePayload?: any): Promise<void> {
    if (!this.hasUnsavedChanges) {
      this.dialogRef.close(closePayload);
      return;
    }

    const continueEditing = await this.ux.showConfirmation(
      'You have unsaved changes. If you leave now, your edits will be lost.',
      'Discard Changes?',
      'Continue Editing',
      'Discard Changes',
    );

    if (!continueEditing) {
      this.dialogRef.close(closePayload);
    }
  }

  protected abstract buildDirtySnapshot(): Record<string, any>;
}
